import React from "react";
import StickerPal from "../../Theme/Icons/StickerPalLogo";
import Logo from "../../Theme/Icons/Logo";
import { useSelector } from "react-redux";

export default function NavUploadImg() {
  const listPhoto = useSelector((state) => state.stickers.listPhoto);
  const uploaded = listPhoto ? listPhoto.thumbnail.length : 0;
  return (
    <div class="flex items-center justify-between px-[64px] max-[420px]:px-[5%] pb-[33px] pt-[27px] w-[100%] bg-main-color">
      <div class="items-center flex">
        <div class="cursor-pointer">
          <a href="/stickers-page" class="flex items-center gap-[8px]">
            <Logo />
            <StickerPal />
          </a>
        </div>
      </div>
      <div class="items-center cursor-pointer">
        <h1 class="text-[#ECECEC] text-[24px] font-textBtn">
          Caricature Style
        </h1>
      </div>
      <div class="cursor-pointer">
        <h2 class="text-[#ECECEC] text-[14px] font-textBtn">
          Upload times: {uploaded}
        </h2>
      </div>
    </div>
  );
}
